(() => {
  const previous = window.floowCartCoordinator;
  previous?.listeners.abort();
  const listeners = new AbortController();
  const coordinator = window.floowCartCoordinator = {
    listeners,
    tail: previous?.tail || Promise.resolve(),
    renderPromise: Promise.resolve(),
    version: previous?.version || 0,
    request: previous?.request || 0,
    get sectionId() {
      return document.querySelector('#floow-cart-drawer')?.getAttribute('section-id');
    },
    get errorMessage() {
      return document.querySelector('#floow-cart-drawer')?.dataset.syncError || 'Please reload the page before trying again.';
    },
    run(operation) {
      const result = this.tail.then(async () => {
        this.version += 1;
        this.request += 1;
        this.clearError();
        return operation();
      });
      this.tail = result.catch(() => {});
      return result;
    },
    clearLoading() {
      document.querySelectorAll('#floow-cart-drawer [loading]').forEach(element => element.removeAttribute('loading'));
    },
    clearError() {
      document.querySelector('#floow-cart-drawer [data-cart-sync-error]')?.remove();
    },
    showError(error) {
      this.clearLoading();
      const drawer = document.querySelector('#floow-cart-drawer');
      if (!drawer) return;
      this.clearError();
      const banner = document.createElement('div');
      banner.dataset.cartSyncError = '';
      banner.className = 'banner banner--error';
      banner.setAttribute('role', 'alert');
      banner.textContent = error?.userMessage || this.errorMessage;
      drawer.querySelector('form')?.prepend(banner);
      window.floowOpenCart();
    },
    parse(html, version = this.version, request = ++this.request) {
      if (typeof html !== 'string' || !html.trim()) throw new Error(this.errorMessage);
      const section = new DOMParser().parseFromString(html, 'text/html');
      if (!section.querySelector('#floow-cart-drawer') || !section.querySelector(`[class="item-count-${this.sectionId}"]`)) {
        throw new Error(this.errorMessage);
      }
      section.floowCartVersion = version;
      section.floowCartRequest = request;
      return section;
    },
    async fetchSection(string) {
      const url = new URL(string, window.location.origin + window.Shopify.routes.root);
      const isCart = url.searchParams.get('section_id') === this.sectionId;
      const version = this.version;
      const request = isCart ? ++this.request : null;
      const response = await fetch(url.href, { cache: 'no-store' });
      if (!response.ok) throw new Error(this.errorMessage);
      const html = await response.text();
      return isCart ? this.parse(html, version, request) : new DOMParser().parseFromString(html, 'text/html');
    },
    async render(data, errorText) {
      const html = data?.sections?.[this.sectionId];
      let section;
      if (typeof html === 'string' && html.trim()) {
        try { section = this.parse(html); } catch (_) {}
      }
      if (!section) section = await this.fetchSection(`?section_id=${encodeURIComponent(this.sectionId)}`);
      return window.floowUpdateCart(section, errorText);
    },
    isCurrent(section) {
      return section?.floowCartVersion === this.version && section?.floowCartRequest === this.request;
    },
    async mutate(path, payload, render = true, errorText) {
      const body = { ...payload };
      if (render) {
        body.sections = [this.sectionId];
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(window.Shopify.routes.root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(data.description || data.message || this.errorMessage);
        error.userMessage = error.message;
        throw error;
      }
      if (render) await this.render(data, errorText);
      return data;
    }
  };
  document.addEventListener('cart:prepare-bundled-sections', event => {
    const sections = event.detail?.sections;
    const id = coordinator.sectionId;
    if (id && Array.isArray(sections) && !sections.includes(id) && sections.length < 5) sections.push(id);
  }, { signal: listeners.signal });
  document.addEventListener('cart:change', event => {
    if (!coordinator.sectionId) return;
    coordinator.renderPromise = coordinator.render(event.detail?.cart).then(() => {
      if (event.detail?.baseEvent === 'variant:add') window.floowAfterProductAdded();
    }).catch(error => coordinator.showError(error)).finally(() => coordinator.clearLoading());
  }, { signal: listeners.signal });
  document.addEventListener('cart:refresh', () => {
    coordinator.renderPromise = coordinator.render().catch(error => coordinator.showError(error)).finally(() => coordinator.clearLoading());
  }, { signal: listeners.signal });
})();
